import { AxiosInstance } from 'axios';

export function createClient(axiosInstance: AxiosInstance) {
    return {
        get: async <TResult = unknown>(url: string) => {
            const res = await axiosInstance.get<TResult>(url);

            return res.data;
        },
        post: async <TPayload, TResult = unknown>(url: string, payload: TPayload) => {
            const res = await axiosInstance.post<TResult>(url, payload);

            return res.data;
        },
        patch: async <TPayload, TResult = unknown>(url: string, payload: TPayload) => {
            const res = await axiosInstance.patch<TResult>(url, payload);

            return res.data;
        },
        put: async <TPayload, TResult = unknown>(url: string, payload: TPayload) => {
            const res = await axiosInstance.put<TResult>(url, payload);

            return res.data;
        },
        delete: async <TResult = unknown>(url: string) => {
            const res = await axiosInstance.delete<TResult>(url);

            return res.data;
        },
    };
}
